import React from "react";
import styled from "styled-components";
import { formatPrice } from "../../util/format";
import { faltaParaPedidoMinimo } from "../../util/orderMinimum";

// Aviso do pedido mínimo (decisão 0017): mesmo desenho da barra de frete grátis, em tom de orientação (sem vermelho).
// Some quando o pedido atinge o mínimo. `comDesconto` muda o texto quando foi o cupom que levou abaixo do mínimo;
// `semBarra` para a mini cesta.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 4px 0 8px;
`;

const Text = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: ${(props) => props.theme.colors.neutral900};
`;

const Bar = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background: ${(props) => props.theme.colors.neutral100};
  overflow: hidden;
`;

const BarFill = styled.div`
  height: 100%;
  width: ${(props) => props.$percentual}%;
  border-radius: 3px;
  background: ${(props) => props.theme.colors.primary};
  transition: width 0.3s;
`;

export default function OrderMinimumNotice({ valorMinimo, base, comDesconto = false, semBarra = false }) {
  const falta = faltaParaPedidoMinimo(base, valorMinimo);
  if (falta <= 0) return null;

  const minimo = Number(valorMinimo);
  const percentual = Math.max(0, Math.min(100, ((Number(base) || 0) / minimo) * 100));

  return (
    <Container>
      <Text>
        {comDesconto
          ? `Com o desconto, o pedido ficou abaixo do mínimo de ${formatPrice(minimo)}. Faltam ${formatPrice(falta)} em produtos.`
          : `Pedido mínimo de ${formatPrice(minimo)}. Faltam ${formatPrice(falta)} em produtos.`}
      </Text>
      {!semBarra && (
        <Bar>
          <BarFill $percentual={percentual} />
        </Bar>
      )}
    </Container>
  );
}
